<template>
  <div
    :class="[$style.blockPaymentsBlocks, 'payment-card', { 'is-currency-match': isCurrencyMatch }]"
    @click="$emit('cardClick')"
  >
    <div :class="$style.blockPaymentBlocksSelf">
      <img :class="$style.blockPaymentBlockSelfImg" :src="payment.logo.url" :alt="payment.name" />
    </div>
    <div :class="$style.blockPaymentsBlocksData">
      <div :class="$style.blockPaymentsBlocksDataTr">
        <span :class="$style.blockPaymentsBlocksDataTrTitle">{{ cardData.tableTypeTitle }}</span>
        <span :class="$style.blockPaymentsBlocksDataTrValue"> {{ payment.paymentType }} </span>
      </div>
      <div :class="$style.blockPaymentsBlocksDataTr">
        <span :class="$style.blockPaymentsBlocksDataTrTitle">{{ cardData.tableFeeTitle }}</span>
        <span :class="$style.blockPaymentsBlocksDataTrValue"> {{ payment.fee }} </span>
      </div>
      <div :class="$style.blockPaymentsBlocksDataTr">
        <span :class="$style.blockPaymentsBlocksDataTrTitle">
          {{ cardData.tableProcessingTimeTitle }}
        </span>
        <span :class="$style.blockPaymentsBlocksDataTrValue">
          {{ payment.paymentProcessingTime }}
        </span>
      </div>
      <div :class="$style.blockPaymentsBlocksDataLimit">
        <div :class="$style.limitTitle">{{ cardData.tableLimitsTitle }}</div>
        <div v-if="payment.limitsMin" :class="$style.blockPaymentsBlocksDataLimitTr">
          <span :class="$style.blockPaymentsBlocksDataTrTitle">
            {{ cardData.paymentLimitsMin }}
          </span>
          <span :class="[$style.blockPaymentTableMinMax, $style.blockPaymentsBlocksDataTrValue]">
            {{ snippet.format(payment.limitsMin) }}
          </span>
        </div>
        <div v-if="payment.limitsMax" :class="$style.blockPaymentsBlocksDataLimitTr">
          <span :class="$style.blockPaymentsBlocksDataTrTitle">
            {{ cardData.paymentLimitsMax }}
          </span>
          <span :class="[$style.blockPaymentTableMinMax, $style.blockPaymentsBlocksDataTrValue]">
            {{ snippet.format(payment.limitsMax) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IPaymentData } from '~/types/payments';

type PaymentsCardData = {
  tableTypeTitle: string;
  tableFeeTitle: string;
  tableProcessingTimeTitle: string;
  tableLimitsTitle: string;
  paymentLimitsMin: string;
  paymentLimitsMax: string;
};

defineProps({
  payment: {
    type: Object as PropType<IPaymentData>,
    required: true,
  },
  cardData: {
    type: Object as PropType<PaymentsCardData>,
    required: true,
  },
  isCurrencyMatch: {
    type: Boolean,
    default: false,
  },
});
defineEmits<{
  (e: 'cardClick'): void;
}>();

const snippet = useSnippet();
</script>

<style lang="scss" module src="./paymentCard.scss"></style>
